import AntImage from "@/components/common/image/AntImage";
import Image from "next/image";
import Link from "next/link";
import { BsFillTagFill } from "react-icons/bs";

export default function BlogCard({ blog }) {

  console.log("blog",blog)
  return (

    <div className="blog-card">
      <Link href={`/blogs/${blog?.slug}`} className="blog-image">
        <AntImage
          src={blog?.thumbnail_url ?? "/images/home/blog-size.png"}
          className="img-icon"
          alt={"Image"}           
        />
      </Link>
      <div className="blog-content">
        <h2 className="title"><Link href={`/blogs/${blog?.slug}`} >{blog.title}</Link></h2>
        <p className="date">
          <span className="day">
            {new Date(blog.created_at).toLocaleDateString('bn-BD', {
              day: 'numeric',
            })}
          </span>
          <span className="month">
            {new Date(blog.created_at).toLocaleDateString('bn-BD', {
              month: 'long',
            })}
          </span>
        </p>
        <div className="meta-data">
          <div className="author">
            <div className="profile">
              <Image
                src={"/images/home/avatar.png"}
                className="img-icon rounded-full"
                alt={"Image"}
                width={20}
                height={20}
              />
            </div>
            <h3 className="name">{blog?.author?.name}</h3>
          </div>
          <div className="tag">
            <div className="tag-icon">
              <BsFillTagFill />
            </div>
            <h3 className="tag_title">ফোকাস</h3>
          </div>

        </div>
      </div>
    </div>

  );
}

